class PieChartD3 extends Tango.Component {
	init() {
		this.state = { };
	}

    widgetDidMount() {
        const root = document.getElementById(this.root);

        // set the dimensions and margins of the graph
        const width = 500,
            height = 250,
            margin = 0;

        // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
        const radius = Math.min(width, height) / 2 - margin

        const svg = d3.select(root)
            .append("svg")
            .attr("width", width)
            .attr("height", height)
            .append("g")
            .attr("transform", `translate(${radius},${radius})`);

        const rawData = {};
        Object.values(this.state.data).forEach(item => {
            const name = item.item1.trim();
            rawData[name] = item.item2;
        });

        // Calculate total for percentage calculation
        const rawTotal = d3.sum(Object.values(rawData));
        const rawKeys = Object.keys(rawData);

        // Aggregate small sectors into "Others" if there are more than 12 sectors
        // and there are sectors smaller than 0.5%
        let data = {};
        if (rawKeys.length > 12) {
            let othersValue = 0;
            const threshold = 0.005; // 0.5%

            rawKeys.forEach(key => {
                const percent = rawData[key] / rawTotal;
                if (percent < threshold) {
                    othersValue += rawData[key];
                } else {
                    data[key] = rawData[key];
                }
            });

            // Only add "Others" if there are aggregated items
            if (othersValue > 0) {
                data["Others"] = othersValue;
            }
        } else {
            data = rawData;
        }

        const keys = Object.keys(data);

        // set the color scale
        const color = d3.scaleOrdinal()
            .domain(keys)
            .range(d3.schemeTableau10);

        // Compute the position of each group on the pie:
        const pie = d3.pie()
            .sort(null) // Do not sort group by size
            .value(d => d[1])
        const data_ready = pie(Object.entries(data))

        // The arc generator
        const arc = d3.arc()
            .innerRadius(radius * 0.5) // This is the size of the donut hole
            .outerRadius(radius)
        const total = d3.sum(Object.values(data));

        const tooltip = d3.select(root)
            .append("div")
            .style("position", "absolute")
            .style("visibility", "hidden")
            .style("background-color", "rgba(0, 0, 0, 0.8)")
            .style("color", "white")
            .style("padding", "8px 12px")
            .style("border-radius", "4px")
            .style("font-size", "12px")
            .style("pointer-events", "none")
            .style("z-index", "1000");

        svg
            .selectAll('allSlices')
            .data(data_ready)
            .join('path')
            .attr('d', arc)
            .attr('fill', d => color(d.data[0]))
            .attr("stroke", "white")
            .style("stroke-width", "2px")
            .style("opacity", 0.7)
            .style("cursor", "pointer")
            .on("mouseenter", function (event, d) {
                d3.select(this)
                    .style("opacity", 1)
                    .attr("stroke", "#ddd")
                    .style("stroke-width", "1px");

                const percent = ((d.data[1] / total) * 100).toFixed(1);
                tooltip
                    .style("visibility", "visible")
                    .text(`${d.data[0]} (${percent}%)`);
            })
            .on("mousemove", function (event) {
                tooltip
                    .style("top", (event.pageY - 10) + "px")
                    .style("left", (event.pageX + 10) + "px");
            })
            .on("mouseleave", function () {
                d3.select(this)
                    .style("opacity", 0.7)
                    .attr("stroke", "white")
                    .style("stroke-width", "2px");

                tooltip.style("visibility", "hidden");
            });

        const legend = svg.selectAll('.legend')
            .data(data_ready)
            .join('g')
            .attr('class', 'legend')
            .attr('transform', (d, i) => `translate(${radius + 20}, ${-radius + i * 20})`);

        legend.append('rect')
            .attr('width', 12)
            .attr('height', 12)
            .attr('fill', d => color(d.data[0]));

        legend.append('text')
            .attr('x', 18)
            .attr('y', 10)
            .style('font-size', '11px')
            .text(d => {
                const percent = ((d.data[1] / total) * 100).toFixed(1);
                return `${d.data[0]} (${percent}%)`;
            });
	}
}

Tango.registerComponent(PieChartD3);